export default {
  TableHead: [
    [
      {
        displayName: 'activity.number',
      },
      {
        displayName: 'activity.username',
      },
      {
        displayName: 'activity.role',
      },
      {
        displayName: 'activity.ipaddress',
      },
      {
        displayName: 'activity.activity',
      },
      {
        displayName: 'activity.timestamp',
      },
      {
        displayName: 'activity.log',
      },
    ],
  ],
};
